<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <HarvestedFrames />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import HarvestedFrames from '@/components/SeasonalAnalysis/HarvestedFrames.vue';

  export default {
    name: 'SeasonalHarvest',
    components: {
      HarvestedFrames
    },
    data: () => ({
      inspection_on: "$vuetify.icons.inspection_on",
    })
  }
</script>
